

// import { createContext, useContext, useState } from "react";
// import * as signalR from "@microsoft/signalr";

// const SignalRContext = createContext(null);

// export const SignalRProvider = ({ children }) => {
//   const [connection, setConnection] = useState(null);
//   const [messages, setMessages] = useState([]);
//   const [dealId, setDealId] = useState(null);

//   const connectToDeal = async (dealId) => {
//     if (connection) return;

//     const conn = new signalR.HubConnectionBuilder()
//       .withUrl("https://localhost:44311/signalr-notificationHub")
//       .withAutomaticReconnect()
//       .build();

//     conn.on("ReceiveMessage", (user, message) => {
//       setMessages(prev => [...prev, { user, message }]);
//     });

//     await conn.start();
//     await conn.invoke("JoinDealGroup", dealId.toString());

//     setConnection(conn);
//     setDealId(dealId);

//     console.log("✅ Connected to deal:", dealId);
//   };

//   const sendDealMessage = async (user, message) => {
//     if (!connection) return;

//     await connection.invoke(
//       "SendMessageToDeal",
//       dealId.toString(),
//       user,
//       message
//     );
//   };

//   return (
//     <SignalRContext.Provider
//       value={{
//         connectToDeal,
//         sendDealMessage,
//         messages,
//         dealId,
//         connection
//       }}
//     >
//       {children}
//     </SignalRContext.Provider>
//   );
// };

// export const useSignalR = () => useContext(SignalRContext);


import React, { createContext, useContext, useState, useEffect } from "react";
import * as signalR from "@microsoft/signalr";
import { SIGNALR_NOTIFICATION_HUB } from "../config/api-config";
import { getToken } from "../Compo/utilis/getToken";

const SignalRContext = createContext(null);

export const SignalRProvider = ({ children }) => {
  const [connection, setConnection] = useState(null);
  const [messages, setMessages] = useState([]);
  const [dealId, setDealId] = useState(null);

  // connectionRef keeps the live conn accessible without stale closure issues
  const connectionRef = React.useRef(null);
  const dealIdRef = React.useRef(null);

  const connectToDeal = async (newDealId, immediateMessage = null) => {
    // 1️⃣ Cleanup old connection using ref (avoids stale closure on repeated calls)
    if (connectionRef.current) {
      try { await connectionRef.current.stop(); } catch (_) {}
      connectionRef.current = null;
      setConnection(null);
      setMessages([]);
      setDealId(null);
    }

    // 2️⃣ Create new connection
    const conn = new signalR.HubConnectionBuilder()
      .withUrl(SIGNALR_NOTIFICATION_HUB, {
        accessTokenFactory: () => getToken() || "",
      })
      .withAutomaticReconnect()
      .build();

    conn.on("ReceiveMessage", (user, message) => {
      setMessages((prev) => [...prev, { user, message }]);
    });

    // Start connection and join group
    await conn.start();
    await conn.invoke("JoinDealGroup", newDealId.toString());

    // Send an immediate message using the fresh conn — avoids stale-closure failures
    // that happen when sendDealMessage is called right after connectToDeal
    if (immediateMessage) {
      const { user, message } = immediateMessage;
      await conn.invoke("SendMessageToDeal", newDealId.toString(), user, message);
    }

    // Persist refs and state
    connectionRef.current = conn;
    dealIdRef.current = newDealId;
    setConnection(conn);
    setDealId(newDealId);
  };

  const sendDealMessage = async (user, message) => {
    // Prefer refs (always current) over state (can be stale in closures)
    const conn = connectionRef.current;
    const did = dealIdRef.current;
    if (!conn || !did) return;
    await conn.invoke("SendMessageToDeal", did.toString(), user, message);
  };

  const leaveDealGroup = async () => {
    const conn = connectionRef.current;
    const did = dealIdRef.current;
    if (conn && did) {
      try {
        await conn.invoke("LeaveDealGroup", did.toString());
        await conn.stop();
      } catch (err) {
        console.error("Error leaving deal group:", err);
      }
      connectionRef.current = null;
      dealIdRef.current = null;
      setConnection(null);
      setMessages([]);
      setDealId(null);
    }
  };


  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (connection) connection.stop();
    };
  }, [connection]);

  return (
    <SignalRContext.Provider
      value={{
        connectToDeal,
        sendDealMessage,
        messages,
        dealId,
         leaveDealGroup,
        connection,
      }}
    >
      {children}
    </SignalRContext.Provider>
  );
};

export const useSignalR = () => useContext(SignalRContext);
